<div class="row">
  <div class="col">
    <div class="card card-nb">
      <div class="card-body">
        <div>
            <app-partner-profile-form
                    submitButtonLabel="app_save"
                    [countries]="countries"
                    [profile]="profile"
                    (formSubmit)="onSubmit($event)"
            >
                <button class="btn btn-link" (click)="onDelete()">
                    {{'app_delete' | i18next}}
                </button>
            </app-partner-profile-form>
        </div>
      </div>
    </div>
  </div>
</div>
